import { render } from "./editCsstmManageModel.vue?vue&type=template&id=ef556bde"
import script from "./editCsstmManageModel.vue?vue&type=script&lang=js"
export * from "./editCsstmManageModel.vue?vue&type=script&lang=js"

import "./editCsstmManageModel.vue?vue&type=style&index=0&id=ef556bde&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__